import { Button, Stack } from '@mui/material';
import React from 'react';
import { DialogPromptSelectTeacher } from '../../api/DialogPromptApi';
import ChatBubble from '../ChatBubble';

import { useHistory, useLocation } from 'react-router-dom';
import { ChineseTeacher, IUser, UserApi } from '../../api/UserApi';
import female_avatar_1 from '../../asset/female_avatar_1.png';
import female_avatar_2 from '../../asset/female_avatar_2.png';
import male_avatar from '../../asset/male_avatar.png';
import AppBarContext from '../../context/AppBarContext';
import { useAudioPlayer } from '../../context/AudioPlayerContext';
import DialogPromptFooterContext from '../../context/DialogPromptFooterContext';
import { handleErrorMessage } from '../ErrorDialog';
import { TeacherIntroductionFemale, TeacherIntroductionFemale2, TeacherIntroductionMale, getAudioByText } from './DialogPromptComponent';

interface DialogPromptSelectTeacherComponentProps {
    dialogPrompt: DialogPromptSelectTeacher;
    setDialogPromptComplete: (dialogPromptId: number) => void;
    showAvatar?: boolean;
    chatBubbleContainerRef: React.RefObject<HTMLDivElement>;
    isSettings?: boolean;
}

const DialogPromptSelectTeacherComponent: React.FC<DialogPromptSelectTeacherComponentProps> = ({ dialogPrompt, setDialogPromptComplete, showAvatar = true, chatBubbleContainerRef, isSettings = false }) => {

    const { setErrorMessage } = React.useContext(AppBarContext)
    const history = useHistory();
    const location = useLocation();

    const { playAudio } = useAudioPlayer();

    const { setActionList, clearFooterList } = React.useContext(DialogPromptFooterContext)

    // const [response, setResponse] = React.useState<string | null>(null);
    // const [responseAudio, setResponseAudio] = React.useState<Blob | null>(null);

    const [chatBubbleDone, setChatBubbleDone] = React.useState(false);

    const [promptAudio, setPromptAudio] = React.useState<Blob | null | undefined>(undefined);
    const [maleAudio, setMaleAudio] = React.useState<Blob | null | undefined>(undefined);
    const [femaleAudio, setFemaleAudio] = React.useState<Blob | null | undefined>(undefined);
    const [female2Audio, setFemale2Audio] = React.useState<Blob | null | undefined>(undefined);

    const [isTeacherSelected, setIsTeacherSelected] = React.useState<boolean>(false);
    const [selectedTeacher, setSelectedTeacher] = React.useState<ChineseTeacher | null>(null);

    React.useEffect(() => {
        clearFooterList();

        getAudioByText(history, setErrorMessage, dialogPrompt.prompt, setPromptAudio, isSettings);
        getAudioByText(history, setErrorMessage, TeacherIntroductionMale, setMaleAudio, isSettings, "male")
        getAudioByText(history, setErrorMessage, TeacherIntroductionFemale, setFemaleAudio, isSettings, "female")
        getAudioByText(history, setErrorMessage, TeacherIntroductionFemale2, setFemale2Audio, isSettings, "female2")
    }, [clearFooterList, dialogPrompt.prompt, history, isSettings, setErrorMessage]);


    const playTeacherIntroductionAudio = React.useCallback((teacher: string) => {
        if (teacher == ChineseTeacher.Male && maleAudio) {
            playAudio(maleAudio)
        } else if (teacher == ChineseTeacher.Female && femaleAudio) {
            playAudio(femaleAudio)
        } else if (teacher == ChineseTeacher.Female2 && female2Audio) {
            playAudio(female2Audio)
        } else {
            const storedOnlyRequiredAudio = localStorage.getItem('onlyRequiredAudio');
            const onlyRequiredAudio = storedOnlyRequiredAudio ? JSON.parse(storedOnlyRequiredAudio) : true;
            if (onlyRequiredAudio == false) {
                throw Error("unknown selected teacher name in local storage " + teacher);
            }
        }
    }, [maleAudio, femaleAudio, female2Audio, playAudio]);

    const updateDbTeacher = React.useCallback((teacher: ChineseTeacher) => {
        const updatedUser: IUser = {
            chinese_teacher: teacher,
        };
        // Call the update function
        UserApi.update(updatedUser)
            .then(() => {
                // Handle the response
            })
            .catch(err => {
                handleErrorMessage(err, setErrorMessage, history, location);
            });
    }, [setErrorMessage, history, location]);

    const handleMale = React.useCallback(async () => {
        setIsTeacherSelected(true);
        setSelectedTeacher(ChineseTeacher.Male);
        localStorage.setItem('teacher', ChineseTeacher.Male);
        playTeacherIntroductionAudio(ChineseTeacher.Male)
    }, [setIsTeacherSelected, setSelectedTeacher, playTeacherIntroductionAudio]);

    const handleFemale = React.useCallback(async () => {
        setIsTeacherSelected(true);
        setSelectedTeacher(ChineseTeacher.Female);
        localStorage.setItem('teacher', ChineseTeacher.Female);
        playTeacherIntroductionAudio(ChineseTeacher.Female)
    }, [setIsTeacherSelected, setSelectedTeacher, playTeacherIntroductionAudio]);

    const handleFemale2 = React.useCallback(async () => {
        setIsTeacherSelected(true);
        setSelectedTeacher(ChineseTeacher.Female2);
        localStorage.setItem('teacher', ChineseTeacher.Female2);
        playTeacherIntroductionAudio(ChineseTeacher.Female2)
    }, [setIsTeacherSelected, setSelectedTeacher, playTeacherIntroductionAudio]);

    const handleConfirm = React.useCallback(() => {
        setDialogPromptComplete(dialogPrompt.id);
        const selectedTeacher = localStorage.getItem('teacher');
        if (selectedTeacher) {
            updateDbTeacher(selectedTeacher as ChineseTeacher)
        }
    }, [setDialogPromptComplete, dialogPrompt.id, updateDbTeacher]);

    React.useEffect(() => {
        if (chatBubbleDone) {
            setActionList([
                <img src={male_avatar} alt="Male" onClick={() => handleMale()}
                    style={{
                        height: '100%', width: 'auto', maxHeight: '56px', borderRadius: "50%",
                        border: selectedTeacher === ChineseTeacher.Male ? "3px solid blue" : "3px solid transparent"
                    }}
                />,
                <img src={female_avatar_1} alt="Female 1" onClick={() => handleFemale()}
                    style={{
                        height: '100%', width: 'auto', maxHeight: '56px', borderRadius: "50%",
                        border: selectedTeacher === ChineseTeacher.Female ? "3px solid blue" : "3px solid transparent"
                    }}
                />,
                <img src={female_avatar_2} alt="Female 2" onClick={() => handleFemale2()}
                    style={{
                        height: '100%', width: 'auto', maxHeight: '56px', borderRadius: "50%",
                        border: selectedTeacher === ChineseTeacher.Female2 ? "3px solid blue" : "3px solid transparent"
                    }}
                />,
                <Button variant="contained" onClick={handleConfirm} disabled={!isTeacherSelected}>
                    Confirm
                </Button>
            ])
        }
    }, [chatBubbleDone, isTeacherSelected, selectedTeacher, handleConfirm, handleFemale, handleFemale2, handleMale, setActionList]);

    return (
        <Stack>
            <ChatBubble
                isTeacher={dialogPrompt.is_teacher}
                message={dialogPrompt.prompt}
                messageAudio={promptAudio}
                showAvatar={showAvatar}
                setChatBubbleDone={setChatBubbleDone}
                chatBubbleContainerRef={chatBubbleContainerRef}
            />
            {/** this is not changing as the teacher selection is changing */}
            {/* {response == null ? null : (
                <ChatBubble
                    isTeacher={dialogPrompt.is_teacher}
                    message={response}
                    messageAudio={responseAudio ? responseAudio : null}
                    showAvatar={showAvatar}
                    chatBubbleContainerRef={chatBubbleContainerRef}
                />
            )} */}
        </Stack>
    );
};

export default DialogPromptSelectTeacherComponent;
